export class GeneratedTemplate {
    fileName: string;
    fileBase64: string;
    accessedFields: string[];
    missingFields: string[];
    messages: string;
}
